/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import {
  ArtifactFormLayout,
  ArtifactFormTitle,
} from '@/features/artifacts/components/ArtifactForm/styles';
import { codeableConceptDisplay } from '@/features/fhir/helpers/fhirpath';

import FormMedicamento, { FormMedicamentoProps } from '../FormMedicamento';

type Props = FormMedicamentoProps;

const AddCondutaMedicamento: React.FC<Props> = ({ ...formProps }) => {
  const title = React.useMemo(
    () =>
      codeableConceptDisplay(formProps.resource, 'medicationCodeableConcept'),
    [formProps.resource],
  );

  return (
    <ArtifactFormLayout>
      <ArtifactFormTitle>{title}</ArtifactFormTitle>
      <FormMedicamento {...formProps} />
    </ArtifactFormLayout>
  );
};

export default AddCondutaMedicamento;
